import { compose, setPropTypes, mapProps } from 'recompose';
import withAnalyticsPageView from 'data/tracking/withAnalyticsPageView';
import withErrorPageView, {
  WithErrorPageViewPropType,
} from 'data/tracking/withErrorPageView';
import { withPlan, WithPlanProps } from 'data/plan/withPlan';
import Errors from 'components/Error';
import buildUrl from 'lib/url';
import { trackLinkEvent } from 'lib/tracking';
import { userHasPlanHoppedError } from 'lib/trackingEvents';
import { ApiError } from 'lib/error';
import { ComponentProps } from 'react';

type UserHasPlanHoppedProps = WithPlanProps & {
  error: ApiError;
};

export default compose<
  ComponentProps<typeof Errors.UserHasPlanHopped>,
  UserHasPlanHoppedProps
>(
  withPlan,
  mapProps((props: UserHasPlanHoppedProps) => ({
    error: props.error,
    theme: props.themes.light,
    seePlansUrl: buildUrl(props, 'PREMIUM_LANDING_PAGE'),
    onSeePlansClick: (event: any) =>
      trackLinkEvent(event, userHasPlanHoppedError.getSeePlans()),
  })),
  setPropTypes({
    ...WithErrorPageViewPropType,
  }),
  withAnalyticsPageView('/error/user-has-plan-hopped/'),
  withErrorPageView('user_has_plan_hopped'),
)(Errors.UserHasPlanHopped);
